var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _g25, _path28, _g26, _path29, _g27, _path30, _g28, _path31, _g29, _path32, _g30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderPatternOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4001,
    height: 213,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 4001,
    height: 213,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.72.16h4000v212H.72V.16Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 6541,
    height: 2160,
    x: -1501,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1500.43-167.84h6539.8v2159.77h-6539.8V-167.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 277,
    height: 366,
    x: -165,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-164.32-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M-19.81-118.67v49.17l37.5 19.84v63.1l45.9-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.8-24.16V-94.3l48.36-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28L29.3 81.6V46.04L-16.6 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 278,
    height: 366,
    x: 111,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.93-167.84H388.2v365.36H111.93v-365.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M256.44-118.67v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.36-24.36Zm-14.07 80.71v29.78l-47.8 24.83v64.94l55.5 28.28 55.49-28.28V46.04L259.67 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 277,
    height: 366,
    x: 388,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M388.19-167.84h276.25v365.36H388.2v-365.36Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M532.7-118.67v49.17l37.5 19.84v63.1l45.9-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L535.91 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 277,
    height: 366,
    x: 664,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M664.44-167.84H940.7v365.36H664.44v-365.36Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M808.96-118.67v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.36-24.36Zm-14.08 80.71v29.78l-47.8 24.83v64.94l55.5 28.28 55.49-28.28V46.04L812.18 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 277,
    height: 366,
    x: 940,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M940.7-167.84h276.25v365.36H940.7v-365.36Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1085.21-118.67v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L1088.44 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 278,
    height: 366,
    x: 1216,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1216.96-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1361.47-118.67v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.78 45.76-89.77-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.49 28.28 55.5-28.28V46.04L1364.7 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 277,
    height: 366,
    x: 1493,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1493.21-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1637.72-118.67v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L1640.95 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    width: 277,
    height: 366,
    x: 1769,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1769.47-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1913.98-118.67v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.49-28.28V46.04L1917.21 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 277,
    height: 366,
    x: 2045,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2045.72-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2190.24-118.67v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.36-24.36Zm-14.08 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L2193.46 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 278,
    height: 366,
    x: 2321,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2321.98-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2466.49-118.67v49.17L2504-49.66v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.49-28.28V46.04L2469.72 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    width: 277,
    height: 366,
    x: 2598,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2598.23-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2742.75-118.67v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76V-5.11l47.82-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.82 24.83v64.94l55.5 28.28 55.5-28.28V46.04L2745.97 70v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    width: 277,
    height: 366,
    x: 2874,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2874.49-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3019-118.67v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L3022.23 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    width: 277,
    height: 366,
    x: 3150,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3150.74-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3295.26-118.67v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.77-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.82 24.83v64.94l55.5 28.28 55.5-28.28V46.04L3298.48 70v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    width: 278,
    height: 366,
    x: 3426,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3427-167.84h276.25v365.36H3427v-365.36Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3571.51-118.67v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.28 55.5-28.28V46.04L3574.74 70v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    width: 277,
    height: 366,
    x: 3703,
    y: -168,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3703.26-167.84h276.25v365.36h-276.25v-365.36Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3847.77-118.67v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.77-45.76V-5.11l47.81-24.16V-94.3l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.49 28.28 55.5-28.28V46.04L3850.99 70v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    width: 277,
    height: 366,
    x: -16,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-15.87 11.6H260.4v365.36H-15.86V11.6Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M128.65 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.36-24.36Zm-14.08 80.71v29.78l-47.8 24.83v64.94l55.5 28.29 55.49-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    width: 277,
    height: 366,
    x: 260,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M260.39 11.6h276.25v365.36H260.4V11.6Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M404.9 60.77v49.17l37.5 19.84v63.1l45.9-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.9 23.96v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    width: 277,
    height: 366,
    x: 536,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M536.65 11.6H812.9v365.36H536.65V11.6Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M681.16 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76L585 282.03v-107.7l47.8-24.16V85.13l48.36-24.36Zm-14.07 80.71v29.78l-47.82 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    width: 278,
    height: 366,
    x: 812,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M812.9 11.6h276.26v365.36H812.9V11.6Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M957.41 60.77v49.17l37.5 19.84v63.1l45.9-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.9 23.96v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    width: 277,
    height: 366,
    x: 1089,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1089.16 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1233.67 60.77v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.49-28.3v-35.54l-45.88 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    width: 277,
    height: 366,
    x: 1365,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1365.41 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1509.93 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.82-24.16V85.13l48.35-24.36Zm-14.08 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "x",
    width: 277,
    height: 366,
    x: 1641,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1641.67 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M1786.18 60.77v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.77 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    width: 278,
    height: 366,
    x: 1917,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1917.92 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA462E",
    fillRule: "evenodd",
    d: "M2062.44 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.77-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.82 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "z",
    width: 277,
    height: 366,
    x: 2194,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2194.18 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2338.69 60.77v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    width: 277,
    height: 366,
    x: 2470,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2470.44 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2614.95 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.77-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.49 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.29-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    width: 277,
    height: 366,
    x: 2746,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2746.69 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M2891.2 60.77v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    width: 278,
    height: 366,
    x: 3022,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3022.95 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3167.46 60.77v49.17l37.5 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.77-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.49 28.29 55.5-28.3v-35.54l-45.88 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    width: 277,
    height: 366,
    x: 3299,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3299.2 11.6h276.25v365.36H3299.2V11.6Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3443.71 60.77v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    width: 277,
    height: 366,
    x: 3575,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3575.46 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3719.97 60.77v49.17l37.51 19.84v63.1l45.88-23.96v113.11l-89.78 45.76-89.77-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.49 28.29 55.5-28.3v-35.54l-45.88 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    width: 277,
    height: 366,
    x: 3851,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3851.71 11.6h276.25v365.36h-276.25V11.6Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFD",
    fillRule: "evenodd",
    d: "M3996.22 60.77v49.17l37.51 19.84v63.1l45.89-23.96v113.11l-89.78 45.76-89.78-45.76v-107.7l47.81-24.16V85.13l48.35-24.36Zm-14.07 80.71v29.78l-47.81 24.83v64.94l55.5 28.29 55.5-28.3v-35.54l-45.89 23.96v-98.91l-17.3-9.05Z",
    clipRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPatternOverlay);
export default __webpack_public_path__ + "static/media/Header-pattern-overlay.1794ba4a051e6e63c6a2dada94f2e98e.svg";
export { ForwardRef as ReactComponent };